export default __webpack_public_path__ + "static/mobile-apps-learning-features-b9c408f6d7cd5ad0e891a1be6c3b2719.png";